module.exports = __webpack_public_path__ + "img/index01.b8dcf955.jpg";